import React from 'react';

const Title = props => (
  <div className="title">
    <h1>{props.text}</h1>
    <span>{props.text}</span>
  </div>
);

export default Title;